import { WebAuth } from 'auth0-js';
import styles from './main.module.css';
import getWebAuth from '../../helpers/hostedConfig';
import Identifier from '../identifier';
import External from '../external';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import Password from '../password';
import Registration from '../registration';

interface RouterProps {
  auth0: WebAuth;
}

const Router: React.FC<RouterProps> = ({ auth0 }: RouterProps) => {
  const { state } = useGlobalState();
  const { page } = state;
  switch (page) {
    case 'identifier':
      return <Identifier />;
    case 'password':
      return <Password auth0={auth0} />;
    case 'external':
      return <External auth0={auth0} />;
    case 'registration':
      return <Registration auth0={auth0} />;
    default:
      return <Identifier />;
  }
};

const Main: React.FC = () => {
  const auth0 = getWebAuth();

  return (
    <main className={styles.container}>
      <div className={styles.holder}>
        <Router auth0={auth0} />
      </div>
    </main>
  );
};

export default Main;
